<template>
  <div class="flex flex-col gap-2">
    <!-- Conta criada pelo Google não tem senha: pedir a "senha atual" seria pedir
         algo que nunca existiu. Ter senha é opcional — o botão do Google continua
         funcionando de qualquer forma. -->
    <p v-if="!hasPassword" class="text-muted mb-1">
      Sua conta entra com o Google e não tem senha. Se quiser também poder entrar com
      e-mail e senha, defina uma aqui.
    </p>

    <div v-if="hasPassword">
      <vs-input
        label="Senha Atual"
        placeholder="Digite sua senha atual."
        type="password"
        id="current_password"
        name="current_password"
        v-model="current_password"
        class="w-full"
      />
    </div>
    <div>
      <vs-input
        :label="hasPassword ? 'Nova Senha' : 'Senha'"
        placeholder="Digite sua nova senha."
        ref="password"
        type="password"
        v-validate="'verify_password'"
        data-vv-as="Senha"
        id="password"
        name="password"
        v-model="password"
        class="w-full"
      />
      <!-- <span class="text-danger text-sm">{{ errors.first('password') }}</span> -->
    </div>
    <div>
      <vs-input
        label="Confirmação Nova Senha:"
        placeholder="Digite a senha novamente."
        type="password"
        v-validate="'confirmed:password'"
        data-vv-as="Confirmação Senha"
        id="password_confirmation"
        name="password_confirmation"
        v-model="password_confirmation"
        class="w-full"
      />
      <!-- <span class="text-danger text-sm">{{ errors.first('password_confirmation') }}</span> -->
    </div>
    <div class="pt-8">
      <b-button
        variant="primary"
        :disabled="!validPassword"
        @click="changePassword"
        class="float-right">
        Salvar
      </b-button>
    </div>
  </div>
</template>

<script>

import {
  BForm, BButton, BFormGroup, BInputGroup, BFormTextarea, BFormCheckbox, BCardText, BFormInput, BCard, BCardHeader, BCardTitle, BCardSubTitle, BCardBody, BCollapse, VBToggle, VBTogglePlugin
} from 'bootstrap-vue'

export default {
  components: {
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardText,
    BFormInput,
    BFormCheckbox,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BCardBody,
    BCollapse,
    VBToggle,
    VBTogglePlugin,
  },
  data: () => ({
    current_password: '',
    password: '',
    password_confirmation: ''
  }),

  computed: {
    /**
     * `has_password` vem do payload do login. Ausência da chave (sessão gravada
     * antes deste campo existir) conta como "tem senha" — que é o caso de toda
     * conta anterior ao login com o Google.
     */
    hasPassword() {
      const userInfoStr = localStorage.getItem('userInfo')
      if (!userInfoStr) return true

      try {
        return JSON.parse(userInfoStr).has_password !== false
      } catch (e) {
        return true
      }
    },
    validPassword() {
      // Sem senha atual o backend recusa (e recusava em silêncio antes: esta tela
      // nunca enviou o campo, e o backend o tratava como opcional).
      if (this.hasPassword && !this.current_password) return false

      return Boolean(this.password) && this.password === this.password_confirmation
    }
  },

  methods: {
    changePassword() {
      this.$vs.loading()

      const payload = {
        userDetails: {
          currentPassword: this.hasPassword ? this.current_password : '',
          password: this.password,
          passwordConfirm: this.password_confirmation
        },
        notify: this.$vs.notify,
        closeAnimation: this.$vs.loading.close,
        acl: this.$acl,
        flags: {
          nohome: true
        }
      }
      this.$store.dispatch('auth/changePasswordAttempt', payload).finally(
        () => {
          this.current_password = ''
          this.password = ''
          this.password_confirmation = ''
        }
      )
    }
  }
}
</script>

<style>

</style>
